import Cliente from "../Cliente";

export const getProjects = () => {
    return Cliente.setBearerToken()
        .getCliente()
        .get(`${process.env.REACT_APP_API_URL}projects/`);
};
